<template>
  <div class="wrapper">
    <AppLogo variant="prelogin" />
    <OTPLoginForm v-if="otp_login" />
    <LoginForm v-else />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import LoginForm from "../../components/Authentication/Login/LoginForm.vue";
import AppLogo from "../../components/Widgets/AppLogo.vue";
import config from '@/utils/const/config';
import OTPLoginForm from "@/components/Authentication/Login/OTPLoginForm.vue";

export default defineComponent({
  name: "LoginPage",
  components: {
    AppLogo,
    LoginForm,
    OTPLoginForm,
  },
  computed: {
    otp_login(): boolean {
      return config.feature.otp_login;
    }
  },
});
</script>
